import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Component
import { ChangePasswordRoutingModule } from "./changepassword-routing.module";
import { CoverComponent } from './cover/cover.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ChangepassworddialogComponent } from './changepassworddialog/changepassworddialog.component';

@NgModule({
  declarations: [
    CoverComponent,
    ChangepassworddialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbToastModule,
    FormsModule,
    ChangePasswordRoutingModule
  ],
  exports: [
    ChangepassworddialogComponent
  ]
})
export class ChangePasswordModule { 
  
}
